export default __webpack_public_path__ + "static/media/school-bench-alt.fa76a070.svg";